import React, { useEffect , useContext } from 'react';
import L from 'leaflet'
import "leaflet.vectorgrid"
import { useMap } from 'react-leaflet';
import { Context } from '../store/reducer';
import { legendArrays } from './DoboxLayerGroup/config';

const VectorGrid = ({id, url, layerName, color, opacity, borderColor}) => {
    const map = useMap()
    const { state } = useContext(Context);

    const getStyles = ($id, properties, propsBorderColor) => {

        let value;
        let color;
        let borderColor;
        let fillColor;
        let useSameColorBorder = false;

        let legendSettings;
        
        if ([
          "vis_95_2",
          "vis_95_3",
          "vis_95_4",
          "vis_95_5",
          "vis_95_6"].includes(id)) {
            
            legendSettings = legendArrays[id];
            
            let operatorType = "lt";
            
            if (id === "vis_95_2") {
                value = properties["MAX_Abs_Z_Min_Abs_Z_Max"];
            } else if (id === "vis_95_3") {
                value = properties["GA_R"];
            } else if (id === "vis_95_4") {
                value = properties["legend"];
                
                borderColor = propsBorderColor;
                operatorType = "lte"; 
            } else if (id === "vis_95_5") {
                value = properties["legend"];

                borderColor = propsBorderColor;
                operatorType = "lte";
            } else if (id === "vis_95_6") {
                value = properties["legend"];
                borderColor = propsBorderColor;
                operatorType = "lte";
            }
            
            value = Number(value);
            
            for(let i=0; i < legendSettings.length; i++) {
                
                // 判定する値
                const targetValue = Number(legendSettings[i].maxValue);
                
                if (color) {
                    continue;
                }
                
                // 0の場合は一致判定とする。
                if (targetValue == 0 && value == 0) {
                    color = legendSettings[i].color;
                    continue;
                }
                
                if (operatorType === "lt") {
                    if (value < targetValue) {
                        color = legendSettings[i].color;
                    }
                } else if (operatorType === "lte") {
                    if (value <= targetValue) {
                        color = legendSettings[i].color;
                    }
                }
            }
            
            if (useSameColorBorder) {
                borderColor = color;
            }
            
            fillColor = color;
        }
        
        return {
            value: value, // debug用にセットしている。clickイベントで使用する。
            opacity: state.opacity,
            fill: true,
            weight: 1,
            color: borderColor,
            borderColor: borderColor,
            fillColor: fillColor,
            fillOpacity: state.opacity
        }
    } 
    
    useEffect(() => {
        const vectorGrid = L.vectorGrid.protobuf(url, {
            interactive:true,
            vectorTileLayerStyles: {
                [layerName]: function(properties){

                    let rankColor
                    if(id == "kasen" || id == "kasen-saidai" || id == "kasen-keizoku" || id == "tsunami"){
                        switch (properties.rank) {
                            case 10:
                                rankColor = id == "kasen-keizoku" ? "#a0d2ff" : "#ffffb3";
                                break;
                            case 20:
                                rankColor = id == "kasen-keizoku" ? "#0041ff" : "#f7f5a9";
                                break;
                            case 30:
                                rankColor = id == "kasen-keizoku" ? "#faf500" : "#f8e1a6";
                                break;
                            case 40:
                                rankColor = id == "kasen-keizoku" ? "#ff9900" : "#ffd8c0";
                                break;
                            case 50:
                                rankColor = id == "kasen-keizoku" ? "#ff2800" : "#ffb7b7";
                                break;
                            case 60:
                                rankColor = id == "kasen-keizoku" ? "#b40068" : "#ff9191";
                                break;
                            case 70:
                                rankColor = id == "kasen-keizoku" ? "#600060" : "#f285c9";
                                break;
                            case 80:
                                rankColor = "#dc7adc";
                                break;
                            default:
                                break;
                        }
                    } else if(id == "takashio" || id == "takashio-isewan" || id == "takashio-saidai"){
                        switch (properties.SINSUIRANK) {
                            case "01":
                                rankColor = "#ffffb3";
                                break;
                            case "02":
                                rankColor = "#f7f5a9";
                                break;
                            case "03":
                                rankColor = "#f8e1a6";
                                break;
                            case "04":
                                rankColor = "#ffd8c0";
                                break;
                            case "05":
                                rankColor = "#ffb7b7";
                                break;
                            case "06":
                                rankColor = "#ff9191";
                                break;
                            case "07":
                                rankColor = "#f285c9";
                                break;
                            case "08":
                                rankColor = "#dc7adc";
                                break;
                            default:
                                break;
                        }
                    } else if(id == "vis_91"){
                        
                        // 91: 地震被害想定図
                        
                        switch (properties["震度階級"]) {
                            case "７":
                                rankColor = "#720000";
                                break;
                            case "６強":
                                rankColor = "#FF0000";
                                break;
                            case "６弱":
                                rankColor = "#FF72DF";
                                break;
                            case "５強":
                                rankColor = "#FFAA00";
                                break;
                            case "５弱":
                                rankColor = "#FFFF00";
                                break;
                            case "４":
                                rankColor = "#38A800";
                                break;
                            case "３":
                                rankColor = "#005CE6";
                                break;
                            case "２":
                                rankColor = "#005CE6";
                                break;
                            case "１":
                                rankColor = "#005CE6";
                                break;
                            case "０":
                                rankColor = "#ffffff";
                                break;
                            default:
                                break;
                        }
                    } else if(id == "toshi_85_1_11"){

                        // 都市計画 各種用途地域
                        switch (properties.YOTO_CD) {
                            case 1:
                                rankColor = "#33C29D";
                                break;
                            case 2:
                                rankColor = "#95DBC5";
                                break;
                            case 3:
                                rankColor = "#93D765";
                                break;
                            case 4:
                                rankColor = "#BDE54D";
                                break;
                            case 5:
                                rankColor = "#EFF17E";
                                break;
                            case 6:
                                rankColor = "#FFDBC4";
                                break;
                            case 7:
                                rankColor = "#FFB75F";
                                break;
                            case 8:
                                rankColor = "#D08833";
                                break;
                            case 9:
                                rankColor = "#FFBFCF";
                                break;
                            case 10:
                                rankColor = "#FF7A63";
                                break;
                            case 11:
                                rankColor = "#B8A9D0";
                                break;
                            case 12:
                                rankColor = "#C7EEFF";
                                break;
                            case 13:
                                rankColor = "#3ED2FF";
                                break;
                            default:
                                break;
                        }

                        borderColor = rankColor;
                        
                    } else if(["85_2_1_land_250m", "85_2_2_land_town", "85_2_3_land_site"].includes(id)){

                        borderColor = "transparent";
                        
                        // 都市計画 現況
                        switch (properties.TOCHI_RY) {
                            case 201:
                                rankColor = "#C3FF33";
                                break;
                            case 202:
                                rankColor = "#D3D333";
                                break;
                            case 203:
                                rankColor = "#33E333";
                                break;
                            case 204:
                                rankColor = "#93E3FF";
                                break;
                            case 224:
                                rankColor = "#F39753";
                                break;
                            case 205:
                                rankColor = "#B3835B";
                                break;
                            case 211:
                                rankColor = "#FFFF33";
                                break;
                            case 212:
                                rankColor = "#EB7373";
                                break;
                            case 225:
                                rankColor = "#F3ABAB";
                                break;
                            case 213:
                                rankColor = "#4B6BFF";
                                break;
                            case 226:
                                rankColor = "#ABB7FF";
                                break;
                            case 219:
                                rankColor = "#FFD373";
                                break;
                            case 214:
                                rankColor = "#D333E3";
                                break;
                            case 215:
                                rankColor = "#FFFFFF";
                                break;
                            case 216:
                                rankColor = "#B3B3B3";
                                break;
                            case 217:
                                rankColor = "#D3FFD3";
                                break;
                            case 218:
                                rankColor = "#AB6B6B";
                                break;
                            case 220:
                                rankColor = "#FBCFBB";
                                break;
                            case 221:
                                rankColor = "#C7D7E3";
                                break;
                            case 222:
                                rankColor = "#CFD3B3";
                                break;
                            case 223:
                                rankColor = "#CBC3CF";
                                break;
                            default:
                                rankColor   = "#000000";
                                borderColor = "#000000";
                                break;
                        }

                    } else if(["85_3_1_building_250m", "85_3_2_building_town", "85_3_3_building_building"].includes(id)){

                        /*
                         * 建物利用現況
                         */
                        
                        borderColor = "transparent";
                        
                        // 文字列と数値がタイルURLによって揺れがあるので、値がある場合は文字列に統一
                        const stringTateYo = properties.TATE_YO 
                                                    ? "" + properties.TATE_YO
                                                    : undefined;

                        switch (stringTateYo) {
                          	// 業務施設
                            case "401":rankColor = "#be1e32"; break;
                            // 商業施設
                            case "402":rankColor = "#785028"; break;
                            // 宿泊施設
                            case "403":rankColor = "#f08cbe"; break;
                            // 商業系用途複合施設
                            case "404":rankColor = "#f06e3c"; break;
                            // 住宅
                            case "411":rankColor = "#f0f0a0"; break;
                            // 共同住宅
                            case "412":rankColor = "#faaaa0"; break;
                            // 店舗等併用住宅
                            case "413":rankColor = "#f0eb5a"; break;
                            // 店舗等併用共同住宅
                            case "414":rankColor = "#f01e28"; break;
                            // 作業所併用住宅
                            case "415":rankColor = "#b48cbe"; break;
                            // 官公庁施設
                            case "421":rankColor = "#0a78be"; break;
                            // 文教厚生施設
                            case "422":rankColor = "#faa032"; break;
                            // 運輸倉庫施設
                            case "431":rankColor = "#283c8c"; break;
                            // 工場
                            case "441":rankColor = "#00643c"; break;
                            // 農林漁業用施設
                            case "451":rankColor = "#3caa82"; break;
                            // 供給処理施設
                            case "452":rankColor = "#5a5a5a"; break;
                            // 防衛施設
                            case "453":rankColor = "#283232"; break;
                            // その他
                            case "454":rankColor = "#a0a0a0"; break;
                            // 不明
                            case "461":rankColor = "#dcdcdc"; break;
                            // 未設定は透明に
                            case undefined:rankColor = "transparent"; break;
                            default:
                                rankColor   = "#000000";
                                borderColor = "#000000";
                                break;
                        }

                    } else if(["85_4_1_population_500m", "85_4_2_population_town"].includes(id)){

                        /*
                         * 性別年齢別人口
                         */

                        borderColor = "transparent";

                        // 文字列と数値がタイルURLによって揺れがあるので、値がある場合はブランク文字と結合することで、強制的に文字列にキャスト
                        const population_density = (properties.population_density !== undefined)
                            ? "" + properties.population_density
                            : undefined;
                        
                        if (population_density === "0") {
                            rankColor = "#FAF0E6"; //linen
                        } else if (population_density === "1") {
                            rankColor = "#fac8b4";
                        } else if (population_density === "2") {
                            rankColor = "#fa8c6e";
                        } else if (population_density === "3") {
                            rankColor = "#fa503c";
                        } else if (population_density === "4") {
                            rankColor = "#c81414";
                        } else if (population_density === "5") {
                            rankColor = "#640000";
                        } else if (population_density === undefined) {
                            rankColor = "transparent";
                        } else {
                            rankColor   = "#000000";
                            borderColor = "#000000";
                        }

                    } else if ([
                        "vis_95_2",
                        "vis_95_3",
                        "vis_95_4",
                        "vis_95_5",
                        "vis_95_6"].includes(id)) {
                        
                        return getStyles(id, properties, borderColor)
                        
                    } else {
                        return {
                            color: borderColor,// 線
                            opacity: state.opacity,
                            fill: true,
                            fillColor: color,
                            dashArray: (id == 'toshi_85_1_1') ? 7 : 0, // 行政区域だけ点線
                            fillOpacity: state.opacity
                        }
                    }

                    return {
                        color: borderColor,// 線
                        opacity: state.opacity,
                        fill: true,
                        fillColor: rankColor,
                        fillOpacity: state.opacity
                    }
                }
            },
        })
        
        vectorGrid.on('click', (e) => {
            // console.log("click地点の値: "+e.layer.options.value);
        });

        vectorGrid.addTo(map)

        return () => vectorGrid.remove()
    }, [state.opacity])

    return null
}

export default VectorGrid
